/*
 * PBFCM and alt product card click tracking. Pushes sale_tile_click with target
 * rating | image | title | atc.
 */
(function fdSaleTileReviews() {
  if (window.fdSaleTileReviews) return;
  window.fdSaleTileReviews = true;

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (err) {
      return;
    }
  }

  function cardMeta(node) {
    var card = node && node.closest && node.closest('[data-fd-sale-tile]');
    if (!card) {
      return {
        product_id: '',
        product_handle: '',
        product_title: ''
      };
    }
    return {
      product_id: card.getAttribute('data-product-id') || '',
      product_handle: card.getAttribute('data-product-handle') || '',
      product_title: card.getAttribute('data-product-title') || ''
    };
  }

  function payload(node, extra) {
    return Object.assign(
      {
        experiment_id: 'SALE_01',
        variant: 'below_price',
        page_path: window.location.pathname
      },
      cardMeta(node),
      extra || {}
    );
  }

  function clickTarget(event) {
    var node = event.target;
    if (!node || !node.closest) return null;
    var rating = node.closest('[data-fd-sale-tile-rating]');
    if (rating) return { kind: 'rating', node: rating };
    var atc = node.closest('[data-fd-sale-tile-atc]');
    if (atc) return { kind: 'atc', node: atc };
    var pdp = node.closest('[data-fd-sale-tile-pdp]');
    if (pdp) {
      var kind = pdp.getAttribute('data-fd-sale-tile-pdp');
      if (kind !== 'image' && kind !== 'title') kind = 'image';
      return { kind: kind, node: pdp };
    }
    return null;
  }

  function onClick(event) {
    var hit = clickTarget(event);
    if (!hit) return;
    track('sale_tile_click', payload(hit.node, {
      target: hit.kind,
      click_href: hit.node.getAttribute('href') || ''
    }));
  }

  document.addEventListener('click', onClick, true);
})();
